import { ApiRequest } from '../apiRequest';
import { PersonalDetails, ChildcareCentreDetails, ChildCalculationResult, FamilyDetails } from '../Calculation/types';

// GravityForms apparently requires input ids to be numeric (input_xyz)
// The interfaces below correspond directly to the "Subsidy Calculator Customers" GravityForms form (See init_customers_form.php)
interface PerChildFields {
    input_100?: string[];
    input_101?: string[];
    input_102?: string[];
    input_103?: string[];
    input_104?: string[];
    input_105?: any;
}

interface GravityFormsPayload extends PerChildFields {
    input_1: string;
    input_2: string;
    input_3: string;
    input_4: string;
    input_5: string;
    input_6: string;
    input_7: string;
    input_8: string;
    input_9: string;
}

export class GravityFormsHelper {
    constructor(private postUrl: string) {
    }   

    public async postDetails(personalDetails: PersonalDetails, childcareCentre: ChildcareCentreDetails | undefined, calculationResults: ChildCalculationResult[], familyDetails: FamilyDetails) {
        console.log(personalDetails,'sdf');
        const request = new ApiRequest();
        const payload: GravityFormsPayload = {
                input_1: personalDetails.preferredName,
                input_2: personalDetails.email,
                input_3: childcareCentre ? childcareCentre.state : "",
                input_4: childcareCentre ? childcareCentre.displayName : "",
                input_5: calculationResults.length.toFixed(0),
                input_6: familyDetails.combinedTaxableIncome === undefined ? "" : familyDetails.combinedTaxableIncome.toFixed(2),
                input_7: familyDetails.activityHoursPerFortnight === undefined ? "" : familyDetails.activityHoursPerFortnight.toFixed(0),
                input_8: familyDetails.subsidyPercentage === undefined ? "" : (100 * familyDetails.subsidyPercentage).toFixed(2),
                input_9: familyDetails.hoursEligableForSubsidyPerFortnight === undefined ? "" : familyDetails.hoursEligableForSubsidyPerFortnight.toFixed(0),                
                input_105: personalDetails.number,
        };

        const weeksPerFortnight = 2;

        const perChildMappings: Array<{name: keyof PerChildFields, accessor: (result: ChildCalculationResult) => string}> = [
            {
                name: 'input_100',
                accessor: result => result.enrolledChild.ageInMonths.toFixed(0)
            },
            {
                name: 'input_101',
                accessor: result => result.enrolledChild.attendSessionsPerWeek.toFixed(0)
            },
            {
                name: 'input_102',
                accessor: result => (result.estimate!.subsidisedFortnightlyCost / weeksPerFortnight).toFixed(2)
            },
            {
                name: 'input_103',
                accessor: result => (result.estimate!.outOfPocketPerFornight / weeksPerFortnight).toFixed(2)
            },
            {
                name: 'input_104',
                accessor: result => result.enrolledChild.attendHoursPerDay.toFixed(0)
            },
        ];

        for (const result of calculationResults) {
            if (!result.estimate) {
                continue;
            }

            for (const mapping of perChildMappings) {
                const key: keyof PerChildFields = mapping.name;
                const mappingItems = payload[key] = payload[key] || [];
                const value = mapping.accessor(result);
                mappingItems.push(value);
            }
        }

        try {
            await request.postJson(this.postUrl, payload);
        } catch (e) {
            console.error(e); // Most likely CORS
        }
    }
}